import CrudSection from "../components/CrudSection";
import FeatureDashboard from "../../../components/base/FeatureDashboard";
import { StatusTextBadge } from "../../../components/base/StatusTextBadge";
import LlamadasLive from "./LlamadasLive";
import CampaignsOutbound from "./CampaignsOutbound";
import ChatInbox from "./ChatInbox";
import ReunionesLive from "./ReunionesLive";
import type { CrudColumn, CrudField } from "../types";

// ===========================================================================
// Tareas y actividades — mock CRUD scaffolds (demo data).
// ===========================================================================

export function TareasDashboard() {
  return (
    <FeatureDashboard noticeKey="crm.mockNotice"
      title="Tareas y actividades"
      subtitle="Pendientes, llamadas y reuniones del equipo"
      icon="ri-task-line"
      stats={[
        { label: "Vencen hoy", value: "7", icon: "ri-calendar-todo-line", change: "2 atrasadas", positive: false },
        { label: "Llamadas (semana)", value: "32", icon: "ri-phone-line" },
        { label: "Reuniones", value: "11", icon: "ri-calendar-event-line" },
        { label: "Completadas", value: "84%", icon: "ri-checkbox-circle-line", change: "+5%", positive: true },
      ]}
      recent={{
        title: "Próximas tareas",
        items: [
          { primary: "Llamar a Acme Logistics", secondary: "Hoy 14:00 · María González", badge: "Llamada", tone: "warn" },
          { primary: "Enviar propuesta CRM", secondary: "Mañana · Carlos Herrera", badge: "Propuesta", tone: "info" },
          { primary: "Reunión Northstar", secondary: "Jue 11:00 · Ana López", badge: "Reunión", tone: "ok" },
        ],
      }}
    />
  );
}

// --- Tareas ----------------------------------------------------------------
interface Tarea extends Record<string, unknown> {
  id: string; titulo: string; tipo: string; responsable: string; vence: string; estado: string;
}
const tareaColumns: CrudColumn<Tarea>[] = [
  { key: "titulo", label: "Tarea" },
  { key: "tipo", label: "Tipo" },
  { key: "responsable", label: "Responsable" },
  { key: "vence", label: "Vence" },
  { key: "estado", label: "Estado", align: "center", render: (r) => <StatusTextBadge value={r.estado} /> },
];
const tareaFields: CrudField[] = [
  { key: "titulo", label: "Título", required: true, placeholder: "Llamar a prospecto" },
  { key: "tipo", label: "Tipo", type: "select", required: true, defaultValue: "Llamada", options: [
    { value: "Llamada", label: "Llamada" }, { value: "Correo", label: "Correo" }, { value: "Reunión", label: "Reunión" },
    { value: "Seguimiento", label: "Seguimiento" }, { value: "Propuesta", label: "Propuesta" },
  ] },
  { key: "responsable", label: "Responsable", placeholder: "María González" },
  { key: "vence", label: "Vence", type: "date" },
  { key: "estado", label: "Estado", type: "select", defaultValue: "Pendiente", options: [
    { value: "Pendiente", label: "Pendiente" }, { value: "En proceso", label: "En proceso" },
    { value: "Completado", label: "Completado" }, { value: "Cancelado", label: "Cancelado" },
  ] },
];
const tareaSeed: Tarea[] = [
  { id: "t1", titulo: "Llamar a Acme Logistics", tipo: "Llamada", responsable: "María González", vence: "2026-06-09", estado: "Pendiente" },
  { id: "t2", titulo: "Enviar propuesta CRM", tipo: "Propuesta", responsable: "Carlos Herrera", vence: "2026-06-10", estado: "En proceso" },
  { id: "t3", titulo: "Seguimiento UrbanFit", tipo: "Seguimiento", responsable: "Ana López", vence: "2026-06-08", estado: "Completado" },
];
export const TareasListSection = () => (
  <CrudSection<Tarea> title="Tareas" subtitle="Pendientes del equipo comercial"
    icon="ri-task-line" columns={tareaColumns} fields={tareaFields} seed={tareaSeed} searchKey="titulo" />
);

// --- Llamadas (LIVE) -------------------------------------------------------
// Real call log: AI + human calls with recording, transcript, caller type and
// the post-call AI qualification. Split into two lateral sub-pages (own routes):
// "Por llamar" (Leads/Empresas tabs) and "Historial". See sections/LlamadasLive.tsx.
export const LlamadasPorLlamarSection = () => <LlamadasLive view="porllamar" />;
export const LlamadasHistorialSection = () => <LlamadasLive view="historial" />;

// --- Campañas de llamadas salientes (LIVE) ---------------------------------
// Upload an Excel of prospects and launch a throttled outbound AI-call campaign
// with a chosen presentation agent. See sections/CampaignsOutbound.tsx.
export const CampanasOutboundSection = () => <CampaignsOutbound />;

// --- Chat (WhatsApp) -------------------------------------------------------
// Conversations inbox: agents chat with their assigned leads over WhatsApp.
// Contact roster is the live leads list; threads/assignment persist locally.
// See sections/ChatInbox.tsx.
export const ChatSection = ChatInbox;

// --- Reuniones (LIVE) ------------------------------------------------------
// Per-agent meeting calendar: each human agent connects their own Google
// Calendar; meetings (lead-linked) and time blocks are created on it, with a
// Meet link. Month / Semana / Hoy views. See sections/ReunionesLive.tsx.
export const ReunionesSection = () => <ReunionesLive />;
